import { render, staticRenderFns } from "./RegFrame.vue?vue&type=template&id=e3568c5e&scoped=true&"
import script from "./RegFrame.vue?vue&type=script&lang=js&"
export * from "./RegFrame.vue?vue&type=script&lang=js&"
import style0 from "./RegFrame.vue?vue&type=style&index=0&id=e3568c5e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3568c5e",
  null
  
)

export default component.exports